/* eslint id-length: [2, {"exceptions":["a","b"]}] */

import { kffIsNumber } from '../util';
import { buildRowProperties, sortArbitrary } from './util';
import { appDefault as constants } from './../../config/config';

export default function mixedSorter(a, b, column, isInverted, aBase, bBase) {
  const aProps = buildRowProperties(a, column, constants);
  const bProps = buildRowProperties(b, column, constants);

  // Wrapups pushed to the top
  if (aProps.wrapup && bProps.wrapup) {
    return (isInverted ? -1 : 1) * aProps.value.localeCompare(bProps.value);
  } else if (aProps.wrapup) {
    return isInverted ? 1 : -1;
  } else if (bProps.wrapup) {
    return isInverted ? -1 : 1;
  }

  // NAs pushed to the bottom
  if (aProps.naData && bProps.naData) {
    const sorted = sortArbitrary(
      aProps.value,
      bProps.value,
      constants.dataNotAvailable,
      isInverted
    );
    if (sorted) {
      return sorted;
    }
  } else if (aProps.naData) {
    return (isInverted ? -1 : 1);
  } else if (bProps.naData) {
    return (isInverted ? 1 : -1);
  }

  // If there is an arbitrary display order, sort that way
  if ((column.sortOrder || []).length) {
    const sorted = sortArbitrary(
      aProps.value,
      bProps.value,
      column.sortOrder
    );
    if (sorted) {
      return sorted;
    }
  }

  if (aProps.value === bProps.value) {
    if (aBase && bBase) {
      return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
    }
    return 0;
  }

  // Is column needed?
  if (aProps.rawValue !== false && bProps.rawValue !== false) {
    let anum = parseFloat(aProps.rawValue);
    let bnum = parseFloat(bProps.rawValue);

    // Is column having < or >
    if (!kffIsNumber(a) &&
        /<|>/g.test(a) && anum === bnum) {
      anum = />/g.test(a) ? ++anum : anum;
      anum = /</g.test(a) ? --anum : anum;
    } else if (!kffIsNumber(b.value) &&
        /<|>/g.test(b) && bnum === anum) {
      bnum = />/g.test(b) ? ++bnum : bnum;
      bnum = /</g.test(b) ? --bnum : bnum;
    }

    return bnum - anum;
  } else if (aProps.rawValue !== false) {
    return -1;
  } else if (bProps.rawValue !== false) {
    return 1;
  }

  // Finally, push symbols below others
  const testStr = /^[a-z0-9\s].*[a-z0-9\s]+$/i;
  const oneWordAtStart = /^([a-z0-9\s].*?\s?){1,}/i;
  if (testStr.test(aProps.value) && !testStr.test(bProps.value) &&
    !oneWordAtStart.test(bProps.value)) {
    return -1;
  } else if (testStr.test(bProps.value) && !testStr.test(aProps.value) &&
    !oneWordAtStart.test(aProps.value)) {
    return 1;
  }

  // Finally give up and fallback to localeCompare
  return aProps.value.localeCompare(bProps.value);
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/sorters/mixedSort.js